import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import DeleteProductMergeDefaultMutation from '@/graphql/contracts/deleteProductMergeDefault.mutation.gql';
import { DeleteProductMergeDefault, DeleteProductMergeDefaultVariables }
  from '@/graphql/contracts/_generated_/deleteProductMergeDefault.mutation';

export default function useDeleteProductMergeDefault() {
  const [deleteProductMergeDefault, { loading, error }] = useMutation<
  DeleteProductMergeDefault,
  DeleteProductMergeDefaultVariables
  >(DeleteProductMergeDefaultMutation, {
    client: apolloClientContracts,
    refetchQueries: ['GetPaginatedFilteredProducts'],
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const deleteMergeDefault = (id: string, successCb?: () => void) => {
    deleteProductMergeDefault({
      variables: { id },
      onCompleted: (data) => {
        if (data.deleteProductMergeDefault.code === 'SUCCESS') {
          notificationService.open({
            title: 'Product Merge Default',
            text: 'Product merge default successfully deleted',
            type: 'success',
          });

          if (successCb) {
            successCb();
          }
        } else {
          notificationService.open({
            title: 'Error',
            text: data.deleteProductMergeDefault.message ?? 'Failed to delete product merge default',
            type: 'danger',
          });
        }
      },
    });
  };

  return {
    deleteMergeDefault,
    isLoadingDeleteMergeDefault: loading,
    errorDeleteMergeDefault: error,
  } as const;
}
